import script from "./VerticalAppNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./VerticalAppNavigation.vue?vue&type=script&setup=true&lang=js"

import "./VerticalAppNavigation.vue?vue&type=style&index=0&id=3abdf7f6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3abdf7f6"]])

export default __exports__